<template>
  <div class="formStepper container-fluid">
    <h1 v-if="title">{{ title }}</h1>

    <ValidationObserver key="root" v-slot="{ handleSubmit, passes, dirty, untouched, errors, invalid }">

      <form @submit.prevent="passes(nextStep)" class="form" @input="updateFormData($event.target)">

        <ValidationObserver v-for="(step, idx) in steps" :key="idx" v-if="activeStep === idx" v-slot="{passed}">
          <component :is="step" v-bind:value.sync="formData"
                     :recaptchaToken.sync="recaptchaToken"></component>
        </ValidationObserver>

      </form>

      <div v-show="!isLastStep" class="container">
        <Row>
          <Col v-if="hasSteps">
            <button v-show="hasSteps" @submit.prevent @click.prevent="prevStep" :disabled="!canGoBack">
              Back
            </button>
          </Col>
          <Col>
            <button class="form-submit" v-if="isLastStep || !hasSteps" @submit.prevent
                    @click.prevent="handleSubmit(submit)">
              Submit
            </button>
            <button class="form-next" v-else @submit.prevent @click.prevent="passes(nextStep)">
              Next
            </button>
          </Col>
        </Row>
      </div>

    </ValidationObserver>

  </div>
</template>

<script>
import {set} from 'lodash'
import {ValidationObserver} from "vee-validate"

import Row from "./layout/Row";
import Col from "./layout/Col";

export default {
  name: 'FormStepper',
  props: ["title", "steps", "formData"],
  data() {
    return {
      activeStep: 0,
      recaptchaToken: ''
    }
  },
  computed: {
    hasSteps() {
      return this.steps.length > 2
    },
    currentStep() {
      return this.steps[this.activeStep]
    },
    isLastStep() {
      return this.activeStep === this.steps.length - 1
    },
    canGoBack() {
      return this.activeStep !== 0
    },
    canGoForward() {
      return !this.isLastStep
    }
  },
  methods: {
    async submit() {
      await this.$recaptchaLoaded();
      const token = await this.$recaptcha('FORWARD_ORDER_SUBMIT');
      this.recaptchaToken = token;
      this.nextStep();
    },
    prevStep() {
      if (this.canGoBack)
        this.activeStep--;
    },
    nextStep() {
      if (!this.isLastStep)
        this.activeStep++;
    },
    updateFormData(elem) {
      const {name, value} = elem;
      set(this.formData, name, value);
    }
  },
  components: {
    Row,
    Col,
    ValidationObserver
  }
}
</script>

<style lang="scss">

.formStepper {

  &.container-fluid, .container-fluid {
    padding: 0;
  }

  .form {
    max-width: none !important;
  }

  .validation-error {
    color: darkred;
    outline-color: darkred;
    border-color: darkred;
  }

  .form-field-label {
    font-weight: 600;
    margin-bottom: 0.5em;
  }

  .form-next {
    border-color: #00477f;
    background: #00477f;
    color: #fff;
    box-shadow: inset 0 -2px 0 0 #022e52;
    padding: 0.25em 2em;
    font-weight: bold;
    text-decoration: none;
    border-radius: 20px;
    font-family: proxima-nova-soft, Helvetica, Arial, sans-serif;
    font-size: 1em;
  }

  .form-submit {
    border-color: #de5e28;
    background: #de5e28;
    color: #fff;
    box-shadow: inset 0 -2px 0 0 #b74a1c;
    padding: 0.25em 2em;
    font-weight: bold;
    text-decoration: none;
    border-radius: 20px !important;
    font-family: proxima-nova-soft, Helvetica, Arial, sans-serif;
    font-size: 1em;
  }

}
</style>
